import { render, staticRenderFns } from "./BBS901P01.vue?vue&type=template&id=aaeba96e&"
import script from "./BBS901P01.vue?vue&type=script&lang=js&"
export * from "./BBS901P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports